export default {
  id: 'ClockInOutModal',
  code: 'CN',
  text: {
    'Clock In/Out': '打卡',
    'Options': '打卡选项',
    'Clock In': '上班',
    'Clock Out': '下班',
    'Date and Time': '日期和时间',
    'Notes': '备注',
    'Save': '保存',
    'Cancel': '取消',
    'Cannot Clock In in Advance': '无法提前打卡',
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/ClockInOut/locale.js